module.exports = __webpack_public_path__ + "img/electronic_no_zone.67c620c5.svg";